/**
 * Gift wrap add-on (cart drawer) - see snippets/pj_gift-wrap.liquid
 * and snippets/pj_gift-wrap-edit.liquid.
 *
 * Uses event delegation on document because the drawer's innerHTML is
 * replaced wholesale on every cart update (CartDrawer.renderContents /
 * CartItems section swaps), which would drop element-bound listeners.
 * The collapsed choice is kept in sessionStorage and re-applied via a
 * MutationObserver so it survives those re-renders too.
 */
(function () {
  'use strict';

  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var COLLAPSE_KEY = 'pj-gift-wrap-collapsed';

  function isCollapsed() {
    try {
      return sessionStorage.getItem(COLLAPSE_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  function setCollapsed(value) {
    try {
      if (value) sessionStorage.setItem(COLLAPSE_KEY, '1');
      else sessionStorage.removeItem(COLLAPSE_KEY);
    } catch (error) {
      /* private mode: state lives only until the next re-render */
    }
  }

  function applyCollapse(root, collapsed) {
    (root || document).querySelectorAll('[data-pj-gift-wrap]').forEach(function (el) {
      el.classList.toggle('pj-gift-wrap--collapsed', collapsed);
      var toggle = el.querySelector('[data-pj-gw-toggle]');
      var body = el.querySelector('[data-pj-gw-body]');
      if (toggle) toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      if (body) body.hidden = collapsed;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    applyCollapse(document, isCollapsed());
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !('MutationObserver' in window)) return;
    new MutationObserver(function () {
      applyCollapse(drawer, isCollapsed());
    }).observe(drawer, { childList: true, subtree: true });
  });

  /* collapse / expand */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-pj-gw-toggle]');
    if (!toggle) return;
    event.preventDefault();
    var next = toggle.getAttribute('aria-expanded') === 'true';
    setCollapsed(next);
    applyCollapse(document, next);
  });

  /* The cart's <cart-drawer-items> has a delegated "change" listener that runs
     quantity validation on any field inside it. The inline gift-note textarea
     lives inside a line item, so its change event (fired on blur when clicking
     Save) would reach that validator and show a spurious
     "increments of undefined" error. Stop it in the capture phase, before it
     reaches the cart handler. */
  document.addEventListener(
    'change',
    function (event) {
      if (event.target && event.target.matches && event.target.matches('[data-pj-gw-note]')) {
        event.stopPropagation();
      }
    },
    true
  );

  /* character counter (add form and inline edit form) */
  document.addEventListener('input', function (event) {
    var note = event.target.closest('[data-pj-gw-note]');
    if (!note) return;
    var wrapper = note.closest('.pj-gift-wrap__note-wrapper');
    var counter = wrapper && wrapper.querySelector('[data-pj-gw-counter]');
    if (!counter) return;
    var remaining = Math.max(0, 100 - note.value.length);
    counter.textContent = counter.dataset.template.replace('[N]', remaining);
  });

  /* style chooser: swap image, price and variant */
  document.addEventListener('change', function (event) {
    var radio = event.target.closest('[data-pj-gw-style]');
    if (!radio) return;
    var wrap = radio.closest('[data-pj-gift-wrap]');
    if (!wrap) return;
    var image = wrap.querySelector('[data-pj-gw-image]');
    var price = wrap.querySelector('[data-pj-gw-price]');
    var addBtn = wrap.querySelector('[data-pj-gw-add]');
    if (image && radio.dataset.image) image.src = radio.dataset.image;
    if (price && radio.dataset.price) price.textContent = radio.dataset.price;
    if (addBtn) addBtn.dataset.variantId = radio.value;
  });

  /* show / hide inline message editor on the wrap line item */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-pj-gw-edit-toggle]');
    if (!toggle) return;
    event.preventDefault();
    var form = toggle.parentElement.querySelector('[data-pj-gw-edit-form]');
    if (!form) return;
    form.hidden = !form.hidden;
    if (!form.hidden) {
      var note = form.querySelector('[data-pj-gw-note]');
      if (note) note.focus();
    }
  });

  /* ---- limit-one PDP button ----------------------------------------------
     Products tagged 'limit-one' (gift packaging) may only sit in the cart
     once. buy-buttons.liquid locks the button server-side on page load; this
     keeps it in sync when the cart changes without a reload — adding from the
     PDP itself, or removing the wrap from the drawer while the PDP is open. */
  function syncLimitOneButtons() {
    var buttons = document.querySelectorAll('[data-pj-limit-one-id]');
    if (!buttons.length) return;
    fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        buttons.forEach(function (btn) {
          var productId = parseInt(btn.dataset.pjLimitOneId, 10);
          var inCart = (cart.items || []).some(function (item) {
            return item.product_id === productId;
          });
          btn.disabled = inCart;
          var label = btn.querySelector('span');
          if (label) {
            label.textContent = inCart ? btn.dataset.pjLabelInCart : btn.dataset.pjLabelAdd;
          }
          // the variant picker re-renders the hidden input and drops the
          // server-rendered disabled attribute, so re-apply it here
          var form = btn.closest('form');
          var idInput = form && form.querySelector('.product-variant-id');
          if (idInput) idInput.disabled = inCart;
        });
      })
      .catch(function () {
        /* leave the server-rendered state untouched on failure */
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    // re-assert on load: the theme's variant JS may have stripped the
    // server-rendered disabled attribute off the hidden variant input
    syncLimitOneButtons();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, syncLimitOneButtons);
    }
  });

  /* Last line of defence: block the add-to-cart form outright while a
     limit-one product is already in the cart. Capture phase so it runs before
     the theme's own submit handler, and immune to attribute stripping. */
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || typeof form.querySelector !== 'function') return;
      var btn = form.querySelector('[data-pj-limit-one-id]');
      if (btn && btn.disabled) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );

  function rerenderDrawer(state) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && state.sections && typeof drawer.renderContents === 'function') {
      drawer.renderContents(state);
    } else {
      window.location.reload();
    }
    // the wrap was just added or removed - refresh any limit-one PDP button
    syncLimitOneButtons();
  }

  function showError(scope, message) {
    var errorEl = scope && scope.querySelector('[data-pj-gw-error]');
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    }
  }

  /* add wrap to cart */
  document.addEventListener('click', function (event) {
    var addBtn = event.target.closest('[data-pj-gw-add]');
    if (!addBtn) return;
    event.preventDefault();
    if (addBtn.getAttribute('aria-busy') === 'true') return;
    addBtn.setAttribute('aria-busy', 'true');

    var wrap = addBtn.closest('[data-pj-gift-wrap]');
    var checked = wrap.querySelector('[data-pj-gw-style]:checked');
    var variantId = parseInt((checked && checked.value) || addBtn.dataset.variantId, 10);
    var noteField = wrap.querySelector('[data-pj-gw-note]');
    var note = noteField ? noteField.value.trim().slice(0, 100) : '';
    var item = { id: variantId, quantity: 1 };
    // stored key is always English ("Message") so the admin/checkout read the
    // same label regardless of storefront language; the drawer translates it
    if (note) item.properties = { Message: note };

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [item],
        sections: SECTIONS,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        return response.json().then(function (state) {
          if (!response.ok || state.status) {
            throw new Error(state.description || state.message || 'error');
          }
          rerenderDrawer(state);
        });
      })
      .catch(function (error) {
        addBtn.removeAttribute('aria-busy');
        showError(wrap, error.message);
      });
  });

  /* save gift message on an existing wrap line */
  document.addEventListener('click', function (event) {
    var saveBtn = event.target.closest('[data-pj-gw-save]');
    if (!saveBtn) return;
    event.preventDefault();
    if (saveBtn.getAttribute('aria-busy') === 'true') return;
    saveBtn.setAttribute('aria-busy', 'true');

    var form = saveBtn.closest('[data-pj-gw-edit-form]');
    var noteField = form.querySelector('[data-pj-gw-note]');
    var note = noteField ? noteField.value.trim().slice(0, 100) : '';

    fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: saveBtn.dataset.lineKey,
        quantity: parseInt(saveBtn.dataset.quantity, 10) || 1,
        properties: { Message: note },
        sections: SECTIONS,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        return response.json().then(function (state) {
          if (!response.ok || state.status) {
            throw new Error(state.description || state.message || 'error');
          }
          rerenderDrawer(state);
        });
      })
      .catch(function (error) {
        saveBtn.removeAttribute('aria-busy');
        showError(form, error.message);
      });
  });
})();
